import { FC } from "react";

interface SectionWithImagesI {
	description: string;
	isBelow?: boolean;
	isFirst: boolean;
	imageURL?: string;
	imageAlt?: string;
	title: string;
}

export const SectionWithImages: FC<SectionWithImagesI> = ({
	description,
	isBelow,
	isFirst,
	imageAlt,
	imageURL,
	title,
}) => {
	return (
		<div className={isBelow ? "mt-24" : "relative"}>
			<div className='lg:mx-auto lg:grid lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-2 lg:gap-24 lg:px-8'>
				<div
					className={`${
						isFirst ? "" : "lg:col-start-2"
					} mx-auto max-w-xl px-4 sm:px-6 lg:mx-0 lg:max-w-none lg:py-16 lg:px-0`}
				>
					<div>
						<div className='mt-6'>
							<h2 className='text-3xl font-bold tracking-tight text-secondary'>
								{title}
							</h2>
							<p className='mt-4 text-lg text-gray-500'>{description}</p>
						</div>
					</div>
				</div>
				<div className='mt-12 sm:mt-16 lg:mt-0'>
					<div className='-ml-48 pr-4 sm:pr-6 md:-ml-16 lg:relative lg:m-0 lg:h-full lg:px-0'>
						<img
							alt={imageAlt}
							className='w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none'
							loading='lazy'
							src={imageURL}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
